const developers = [
  {
    id: 'av',
    source:
      'https://dkj231ikyz7c1.cloudfront.net/uploads/rocketeer/profile_image/99/image_440x720_IMG_8288_edited.jpg',
  },
  {
    id: 'bd',
    source:
      'https://dkj231ikyz7c1.cloudfront.net/uploads/rocketeer/profile_image/36/image_440x720_brian-dunn.jpg',
  },
  {
    id: 'ce',
    source:
      'https://dkj231ikyz7c1.cloudfront.net/uploads/rocketeer/profile_image/84/image_440x720_chris-erin.jpg',
  },
  {
    id: 'dh',
    source:
      'https://dkj231ikyz7c1.cloudfront.net/uploads/rocketeer/profile_image/94/image_440x720_dillon-hafer.jpg',
  },
  {
    id: 'dk',
    source:
      'https://dkj231ikyz7c1.cloudfront.net/uploads/rocketeer/profile_image/91/image_440x720_dorian-karter.jpg',
  },
  {
    id: 'gr',
    source:
      'https://dkj231ikyz7c1.cloudfront.net/uploads/rocketeer/profile_image/47/image_440x720_gabriel-reis.jpg',
  },
  {
    id: 'jw',
    source:
      'https://dkj231ikyz7c1.cloudfront.net/uploads/rocketeer/profile_image/86/image_440x720_jake-worth-headshot-2020-cropped-for-hr-3.jpeg',
  },
  // {
  //   id: 'jb',
  //   source:
  //     'https://dkj231ikyz7c1.cloudfront.net/uploads/rocketeer/profile_image/88/image_440x720_josh-branchaud.jpg',
  // },
  {
    id: 'mb',
    source: 'https://avatars0.githubusercontent.com/u/5210361?s=400&v=4',
  },
  {
    id: 'ml',
    source: require('profiles/ml.jpg'),
  },
  {
    id: 'mp',
    source:
      'https://dkj231ikyz7c1.cloudfront.net/uploads/rocketeer/profile_image/35/image_440x720_matt-polito.jpg',
  },
  {
    id: 'pc',
    source:
      'https://dkj231ikyz7c1.cloudfront.net/uploads/rocketeer/profile_image/105/image_440x720_IMG_2469_1_.jpg',
  },
  {
    id: 'rm',
    source: require('profiles/rm.jpg'),
  },
  // {
  //   id: 'tm',
  //   source:
  //     'https://dkj231ikyz7c1.cloudfront.net/uploads/rocketeer/profile_image/43/image_440x720_taylor-mock.jpg',
  // },
  {
    id: 've',
    source:
      'https://dkj231ikyz7c1.cloudfront.net/uploads/rocketeer/profile_image/96/image_440x720_vidal-ekechukwu.jpg',
  },
  {
    id: 'vn',
    source: require('profiles/vn.jpg'),
  },
  {
    id: 'hr',
    source: require('profiles/hr.jpg'),
  },
  {
    id: 'wolf',
    source: require('profiles/wolf.jpg'),
  },
  {
    id: 'ufo',
    source: require('profiles/ufo.jpg'),
  },
  {
    id: '?',
    source: require('profiles/unknown.jpg'),
  },
];

export default developers;



// WEBPACK FOOTER //
// ./src/data/developers.js